import React from "react";
import clsx from "clsx";
import styles from "./styles.css.js";
import ItemsList from "../items-list";
var CategoryElement = function(_a) {
    var _b;
    var item = _a.item, onItemActivate = _a.onItemActivate, onGroupToggle = _a.onGroupToggle, targetItem = _a.targetItem, isHighlighted = _a.isHighlighted, isKeyboardHighlight = _a.isKeyboardHighlight, isExpanded = _a.isExpanded, highlightItem = _a.highlightItem, disabled = _a.disabled, variant = _a.variant;
    // Hide the category title element from screen readers because it will be
    // provided as an ARIA label.
    return /*#__PURE__*/ React.createElement("li", {
        className: clsx(styles.category, styles["variant-".concat(variant)], disabled && styles.disabled),
        role: "presentation",
        "aria-disabled": disabled ? "true" : undefined
    }, item.text && /*#__PURE__*/ React.createElement("p", {
        className: clsx(styles.header, (_b = {}, _b[styles.disabled] = disabled, _b)),
        "aria-hidden": "true"
    }, item.text), /*#__PURE__*/ React.createElement("ul", {
        className: clsx(styles["items-list-container"]),
        role: "group",
        "aria-label": item.text
    }, item.items && /*#__PURE__*/ React.createElement(ItemsList, {
        items: item.items,
        onItemActivate: onItemActivate,
        onGroupToggle: onGroupToggle,
        targetItem: targetItem,
        isHighlighted: isHighlighted,
        isKeyboardHighlight: isKeyboardHighlight,
        isExpanded: isExpanded,
        highlightItem: highlightItem,
        categoryDisabled: disabled,
        hasCategoryHeader: !!item.text,
        variant: variant
    })));
};
export default CategoryElement; //# sourceMappingURL=category-element.js.map
